/*
 * File: /src/router/routes/connectors.js
 * Created Date: Tuesday September 16th 2025
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Copyright (c) 2025 AdBase, Inc.
 */

const ConnectorStatusList = () =>
  import(
    /* webpackChunkName: "Connector" */ 'src/components/Dashboard/Views/Connector/ConnectorStatusList.vue'
  );

export const connectorRoutes = [
  {
    path: 'connectors/status',
    name: 'Connector Status',
    component: ConnectorStatusList,
  },
];
